import { render, staticRenderFns } from "./RegisterRootView.vue?vue&type=template&id=11c22cce"
import script from "./RegisterRootView.vue?vue&type=script&lang=js"
export * from "./RegisterRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports